// Aviso de somente leitura (AC-107): sem assinatura ativa, a lista aparece só para ver, com
// "Assinar" levando aos planos. Sem teste grátis desde 28/10/2026 (AC-101).
import { useTranslation } from 'react-i18next';
import { useNav } from '../state/services';
import { useAccess } from '../state/useSubscription';
import { Icon } from './Icon';

export function ReadOnlyBanner() {
  const { t } = useTranslation();
  const access = useAccess();
  const nav = useNav();
  if (!access.subscription || access.hasAccess) return null;
  return (
    <div className="banner banner--locked" role="status" data-testid="read-only-banner">
      <Icon name="lock" size={15} />
      <span>{t('trial.readOnly')}</span>
      <button type="button" className="btn btn--honey btn--sm" onClick={() => nav.go('subscription')}>
        {t('trial.subscribe')}
      </button>
    </div>
  );
}
